import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { BaseControl, ConfirmComponent, Rol, TablaMaestra, Const } from "@app/shared";
import { LocalDataSource } from "ng2-smart-table";
import { ToastrService } from "ngx-toastr";
import { ManagementMasterTableDataService } from "./shared/management-mastertable.data.service";
import { ManagementMasterTableConfig } from "./shared/management-mastertable.config.service";
import { ManagementMasterTableFormService } from "./shared/management-mastertable.form.service";
import { AuthenticationService } from "@app/core";
import { async } from "@angular/core/testing";

@Component({
  selector: "iw-management-mastertable-permission",
  templateUrl: "./management-mastertable-permission.component.html",
  styleUrls: ["./management-mastertable-permission.component.scss"],
  providers: [ManagementMasterTableDataService, ManagementMasterTableFormService],
})
export class ManagementMastertablePermissionComponent implements OnInit {
  // formulario de agregar permisos
  form: FormGroup = new FormGroup({
    cboGroup: new FormControl(null),
  });
  // Contiene los roles(Grupos) para listar en el select
  roles: Array<Rol> = [];
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Contiene el id del grupo seleccionado
  idGroupSelect = -1;
  // Define la accion a realizar en el formulario
  actionForm = "";
  // Contiene los controles del formulario
  controls: BaseControl<any>[] = [];
  // Lista de maestras
  masterTables: TablaMaestra[] = [];
  // id de la maestra seleccionada para modificar
  id_master_table: any = null;
  // Pregunta de la modal de confirmaciones
  question = '';
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild("ngSelect") ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;



  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
    estructure: false,
    createUserSystem: false,
    reviewUserSystem: false,
    updateUserSystem: false,
    deleteUserSystem: false,
    buildStructure: false,
    reviewStructure: false,
    deleteStructure: false,
  };

  constructor(
    private mmds: ManagementMasterTableDataService,
    private toastr: ToastrService,
    private mmfs: ManagementMasterTableFormService,
    private as: AuthenticationService,
  ) {}

  ngOnInit() {
    this.mmds.getRoles().subscribe((roles) => (this.roles = roles));
    this.form.controls["cboGroup"].valueChanges.subscribe((data) => this.selectRol(data));
    const configTable = new ManagementMasterTableConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
    this.mmds.getMasterTables().then(async res=>{
      if(res){
        this.masterTables = await res
      }
    })

    // Validacion de permisos
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.created,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.delete,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.update,
    );
    // Fin validacion
  }

  /**
   *Controla el evento de seleccionar un rol(Grupo) en el select principal
   *
   * @param {*} data
   * @memberof ManagementMastertablePermissionComponent
   */
  selectRol(data: any) {
    if (data) {
      this.idGroupSelect = data;
      this.mmds.getRolesPermission(this.idGroupSelect).subscribe((permissions) => {
        if (permissions) {
          permissions.forEach((p) => {  
            p["detail"] = true;
          });
          this.sourceData = new LocalDataSource(permissions);
          this.sourceData.refresh();
        }
      });
    } else {
      this.idGroupSelect = -1;
    }
    // if (this.activateAction.review) {
    //   if (data) {
    //     this.idGroupSelect = data;
    // this.mgpds.getRolesPermission(this.idGroupSelect).subscribe(permissions => {
    //       if (permissions && permissions.permisos.length) {
    //         permissions.permisos.forEach(permission => {
    //           permission.nombre = permission.nombre.replace(/\_/g, ' ');
    //           permission.nombre = permission.nombre.charAt(0).toUpperCase() + permission.nombre.slice(1);
    //           permission.tipo_permiso = permission.tipo_permiso.replace(/\_/g, ' ');
    //           // tslint:disable-next-line:max-line-length
    //           permission.tipo_permiso = permission.tipo_permiso.charAt(0).toUpperCase() + permission.tipo_permiso.slice(1);
    //         });
    //         permissions.permisos.sort((a, b) => {
    //           if (a.tipo_permiso > b.tipo_permiso) {
    //             return 1;
    //           }
    //           if (a.tipo_permiso < b.tipo_permiso) {
    //             return -1;
    //           }
    //           // a must be equal to b
    //           return 0;
    //         });
    //       }
    //       this.permissionsGroup = permissions.permisos;
    //       this.sourceData = new LocalDataSource(permissions.permisos);
    //       this.sourceData.refresh();
    //     });
    //   } else {
    //     this.idGroupSelect = -1;
    //   }
    // } else {
    //   this.toastr.error('Usted no posee permisos para ver los permisos de los grupos del sistema', 'Permiso denegado');
    // }
  }

  /**
   * Controla las acciones a realizar con los permisos
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ManagementGroupsPermissionComponent
   */
  defineActionCondictions(action: "add" | "update" | "delete" = "add", data?: any) {
    switch (action) {
      case "add":
        if (this.activateAction.created) {
        this.formOpen = true;
        this.actionForm = "Agregar";
        this.controls = this.mmfs.getFormRol({ ngSelect: this.ngSelectTpl }, null);
          // this.formOpen = true;
          // this.actionForm = 'Agregar';
          // this.controls = this.mmfs.getFormRol(
          //     {ngSelect: this.ngSelectTpl}, null
          // );
        } else {
          this.toastr.warning(
            'Usted no posee permisos para agregar maestras a los grupos del sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.actionForm = "Modificar";
          //this.id_master_table = data.id_maestra;
          this.id_master_table = data.id;
          this.controls = this.mmfs.getFormRol({ ngSelect: this.ngSelectTpl }, data);
        } else {
          this.toastr.warning(
            'Usted no posee permisos para actualizar permisos a las maestras de los grupos del sistema',
            'Permiso denegado'
          );
        }
        break;
      case "delete":
        if (this.activateAction.delete) {
          this.question = '¿Realmente desea eliminar la maestra del grupo?';
          //this.id_master_table = data.id_maestra;
          this.id_master_table = data.id;
          this.confirm.open();
        } else {
          this.toastr.warning(
            'Usted no posee permisos para eliminar permisos a las maestras de los grupos del sistema',
            'Permiso denegado'
          );
        }
        break;
    }
  }

  /**
   *Cierra el formulario o reinicia el componete a la tabla principal
   *
   * @memberof ManagementMastertablePermissionComponent
   */
  closeFormRol() {
    this.actionForm = "";
    this.formOpen = false;
  }

  /**
   *Controla el evento de guardar en el formulario de asociar permisos a un rol(Grupo)
   *
   * @param {*} data
   * @memberof ManagementMastertablePermissionComponent
   */
   sended(data: any) {
    if (data) {
      let formData = {
        id_maestra: data.cboTypeMaster,
        id_rol: this.idGroupSelect,
        ver: data.chWatch,
        crear: data.chCreate,
        eliminar: data.chDelete,
        modificar: data.chUpdate
      }
      if(this.actionForm == 'Agregar'){
        this.mmds.addMasterTable(formData).then(async res=>{
          if(res){
            // Movemos el metodo para que espere la respuesta y refresque la tabla
            await this.selectRol(this.idGroupSelect);
          }
        }, err=>{
          // console.log(err)
        })
      }else if(this.actionForm == 'Modificar'){
        this.mmds.updateMasterTable(this.id_master_table, formData).then(async res=>{
          if(res){
            // Movemos el metodo para que espere la respuesta y refresque la tabla
            await this.selectRol(this.idGroupSelect);
          }
        }, err=>{
          // console.log(err)
        })
      }
      // this.selectRol(this.idGroupSelect); // Poner a esperar
      this.closeFormRol();
    }
  }

   /**
    *Controla la respuesta del modal de confirmaciones
    *
    * @param {boolean} res
    * @memberof ManagementMastertablePermissionComponent
    */
   actionComfirm(res: boolean) {
    if (res) {
      this.mmds.deleteMasterTable(this.id_master_table).then(async res=>{
        if(res){
          await this.selectRol(this.idGroupSelect);
        }
      }, err=>{
        // console.log(err);
      })
      // this.selectRol(this.idGroupSelect);
    }
    this.question = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-mastertable-permission/management-mastertable-permission.component.ts